import React from 'react'
import { CarouselItem } from './carousel-item'
import { LeftContent } from './left-content'
import { RightContent } from './right-content'
import { PrincipalAppStoreButtons } from '../../../principal-app-store-buttons'

export const PrincipalHero = () => {
  return (
    <CarouselItem>
      <LeftContent
        description="With our mobile or web app, your milk producers can do self-service to review or download test results, milk pickups, and download financial reports."
        title="Mobile and Web App for Milk Producer"
      >
        <PrincipalAppStoreButtons className="animate__animated animate__fadeInUp" />
      </LeftContent>

      <RightContent url="principal/principal-mobile.png" alt="principal mobile app" />
    </CarouselItem>
  )
}
